import { combineReducers } from '@reduxjs/toolkit'
import eventLog from '../app/customer/locations/components/TabEvents/state/slice'
import analytics from '../app/customer/analytics/state/slice'
import widgets from '../app/customer/widgets/state/slice'
import remote from '../app/customer/locations/state/sliceRemote'

const combinedReducer: any = combineReducers({
  analytics,
  eventLog,
  remote,
  widgets,
})

const rootReducer = (state: any, action: any) => {
  if (action.type === 'cache/clearAll') {
    console.log('🧹 Clearing all Redux cache/state...')
    state = undefined
  }
  return combinedReducer(state, action)
}

export type RootState = ReturnType<typeof rootReducer>

export default rootReducer
